import React from "react";
import { useTranslation } from "react-i18next";
import { FilmSlate } from "@phosphor-icons/react";
import VideoLibrary from "../components/VideoLibrary";

// v414.80 — in-app Video Library (distributor portal + org roles).
// Same clips as the storefront version at /{code}/videos.
export default function VideoLibraryPage() {
  const { t } = useTranslation();
  return (
    <div className="space-y-6" data-testid="video-library-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight flex items-center gap-2.5">
          <FilmSlate size={26} weight="bold" className="text-[#8a6a1c]" />
          {t("library.title")}
        </h1>
        <p className="text-sm text-zinc-600 mt-1">{t("library.subtitle")}</p>
      </div>
      <VideoLibrary />
    </div>
  );
}
